import axios from 'axios';

import { Global } from './global';

const BASE_URL = './';

async function getLeaderData() {
  const res = await axios.post(
    `${BASE_URL}getLeader.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
          vehicle: null,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}
async function registerUser() {
  const res = await axios.post(
    `${BASE_URL}userInfo.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
          data: {
            name: Global.userName,
            email: Global.email,
          },
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}
async function updateClick(saveType) {
  const res = await axios.post(
    `${BASE_URL}valueUpdator.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
          saveType,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}

async function createUser() {
  const res = await axios.post(
    `${BASE_URL}create.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}

async function saveGameData() {
  console.log(Global.gameDataToSent, 'Global.gameDataToSent');
  const res = await axios.post(
    `${BASE_URL}saveGameData.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
          data: Global.gameDataToSent,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}
async function updateGameData() {
  const res = await axios.post(
    `${BASE_URL}updateGameData.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
          data: Global.gameDataToSent,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}

async function updateUserData() {
  const res = await axios.post(
    `${BASE_URL}userInfo.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uuid: localStorage.getItem('uuid'),
          data: Global.userDataToSent,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}

async function sendEmail(name, email, mobile, comments, redirectUrl) {
  const res = await axios.post(
    `${BASE_URL}sendEmail.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uid: localStorage.getItem('uuid'),
          name: name,
          email: email,
          mobile: mobile,
          email: email,
          comments: comments,
          redirectUrl: redirectUrl,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}
async function saveImage(base64_image) {
  const res = await axios.post(
    `${BASE_URL}saveImage.php`,
    {
      data: window.btoa(
        JSON.stringify({
          uid: localStorage.getItem('uuid'),
          base64_image: base64_image,
        })
      ),
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  return JSON.parse(window.atob(res['data']));
}

export {
  createUser,
  updateUserData,
  saveGameData,
  updateGameData,
  getLeaderData,
  updateClick,
  registerUser,
};
